export const ensureWeHaveTwoLetterPlaceHolders = (dateFormat) => {
  let result = dateFormat;
  result = result.replace(/\bD\b/, 'DD');
  result = result.replace(/\bM\b/, 'MM');
  return result;
};

export const getPlaceHolderBasedMaskConfiguration = (dateFormat) => {
  let result = dateFormat;
  result = ensureWeHaveTwoLetterPlaceHolders(result);
  result = result.replace(/D/, 'd'); // Replace the first 'D' with a 'd'.
  result = result.replace(/M/, 'm'); // Replace the first 'M' with a 'm'.
  return result;
};

export const getDayMonthPartsConfiguration = (dateFormat, value) => {
  let dayPart, monthPart;
  const dayPartIndex = dateFormat?.toUpperCase()?.indexOf('DD');
  const monthPartIndex = dateFormat?.toUpperCase()?.indexOf('MM');

  if (value) {
    dayPart = value.substring(dayPartIndex, dayPartIndex + 2);
    monthPart = value.substring(monthPartIndex, monthPartIndex + 2);
  }

  return { dayPart, monthPart };
};
